// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** São Tomé & Príncipe */
const ST = /^(?:900[5-9]\d{3}|9(?:0[1-9]|[89]\d)\d{4})$/;

export default ST;
